/** The same URL with a fresh cache-busting `v`, keeping every existing param.
 *
 * `location.reload()` is not enough: it re-requests the SAME url, which the web view may answer
 * from its HTTP cache — and index.html was long served with `max-age=3600`, so a device could sit
 * on an hour-old build referencing a deleted bundle hash and reload straight back into it. A URL
 * it has never seen cannot be answered from cache.
 *
 * `webext_uuid` and friends must survive: dropping them strands the extension with no install id.
 *
 * Lives outside `VersionBadge.tsx` so that file exports only its component — a module mixing
 * components and helpers loses Fast Refresh for the whole file.
 */
export function cacheBustedUrl(href: string, stamp: number): string {
  const url = new URL(href)
  url.searchParams.set('v', stamp.toString(36))
  return url.toString()
}
